import React, { useState, useEffect } from 'react';
import 'leaflet/dist/leaflet.css';
import './App.css';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Map from './components/Map';
import AudioPlayer from './components/AudioPlayer';
import { locations } from './config/locations';
import { startPositionTracking } from './services/geolocationService';
import { Position } from './types';

const App: React.FC = () => {
  const [currentPosition, setCurrentPosition] = useState<Position | null>(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState<string | null>(null);

  useEffect(() => {
    const stopTracking = startPositionTracking(setCurrentPosition);
    return stopTracking;
  }, []);

  const handleRecenter = () => {
    startPositionTracking(setCurrentPosition);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleLocationSelect = (id: string) => {
    setSelectedLocation(id);
    if (window.innerWidth <= 768) {
      setIsSidebarOpen(false);
    }
  };
  
  const currentLocData = locations.find(loc => loc.id === selectedLocation);
  const audioTracks = currentLocData ? currentLocData.tracks : [];
  const [selectedTrackId, setSelectedTrackId] = useState<string | null>(null);

  // When location changes, select the first track by default
  useEffect(() => {
    if (currentLocData && currentLocData.tracks.length > 0) {
      setSelectedTrackId(currentLocData.tracks[0].id);
    } else {
      setSelectedTrackId(null);
    }
  }, [selectedLocation, currentLocData]);

  const currentTrack = audioTracks.find(t => t.id === selectedTrackId) || audioTracks[0];

  return (
    <div className="app-container">
      <Header onMenuClick={toggleSidebar} />
      
      <Sidebar
        isOpen={isSidebarOpen}
        onClose={toggleSidebar}
        locations={locations}
        selectedLocationId={selectedLocation}
        onLocationSelect={handleLocationSelect}
      />
      
      <Map
        locations={locations}
        currentPosition={currentPosition}
        onLocationSelect={handleLocationSelect}
        onMapClick={() => setSelectedLocation(null)}
        onRecenter={handleRecenter}
        selectedLocationId={selectedLocation}
      />

      {currentTrack && (currentTrack.seriousAudioUrl || currentTrack.slangAudioUrl) && (
        <AudioPlayer 
          seriousAudioUrl={currentTrack.seriousAudioUrl}
          slangAudioUrl={currentTrack.slangAudioUrl}
          title={currentTrack.title}
          availableTracks={audioTracks}
          onTrackSelect={setSelectedTrackId}
          currentTrackId={currentTrack.id}
        />
      )}
    </div>
  );
};

export default App;